
import Header from "./header/Header";
import Footer from "./footer/Footer";
import About from "./about/About";
import Cart from "./cart/Cart";
import Plane from "./plane/Plane";
import Question from "./question/Question";
import Accordion from "./accordion/Accordion";

export default function Body(){
    // let element = {
    //     title:"React", teacher:"Aytak Delavar",hours:"10"
    // }
    // function submit(event){
    //     event.preventDefault()
    //     console.log("hello")
    // }
    // let [counter,setCounter]= useState(0)
    // let [message,setMessage]= useState("open")
    // function click(){
    //     console.log("open")
    //     setMessage("close")
    //     setCounter(counter+=1)
    // }
    
    return(
        <div className="w-f">
            <Header/>
            <About/>
            <Cart/>
            <Plane/>
            <Accordion/>
            <Question/>
            <Footer/>
            
            {/* <Header element={element}/>
            <Header  title="Aysal Delavar" teacher="js learning" hours="20 hours"/>
            <Header title="Nayer hoseinpour" teacher="wp learning" hours="25 hours"/> */}
            {/* <Header submit={submit}/>
            <h2>The value of counter is:{counter}</h2>
            <button  onClick={click}>{message}</button> */}

        </div>
    )
}